import { styled, flexCenter, Theme, Colors } from '@unfold/theme';
import { isString } from '@unfold/utils';
import { Typography } from '@unfold/typography';

const getWidth = (width: string | number | undefined = '100%') => {
  return isString(width) ? width : `${width}px`;
};

const getHeight = (height: string | number | undefined = 134) => {
  return isString(height) ? height : `${height}px`;
};

export const DropzoneContainer = styled.div<{
  width?: number | string;
  height?: number | string;
}>`
  width: ${({ width }) => getWidth(width)};
  height: ${({ height }) => getHeight(height)};
  cursor: pointer;
  background-color: #fafafa;
  border: 1.2px dashed #cccccc;
  ${flexCenter}
`;

export const StyledLabel = styled(Typography)`
  font-size: 16px;
  color: ${({ theme }): string =>
    theme.name === Theme.LIGHT ? Colors.G300 : Colors.G600};
`;

export const StyledText = styled(StyledLabel)`
  margin-top: 20px;
  b {
    color: ${({ theme }): string =>
      theme.name === Theme.LIGHT ? Colors.BLACK : Colors.G600};
    font-weight: 500;
    cursor: pointer;
  }
`;

export const InlineButton = styled.button`
  border: none;
  background: none;
  display: inline;
  padding: 0;
  margin: 0;
  font: inherit;
`;
